module.exports = __webpack_public_path__ + "static/media/3.14_preview.613d99a0.png";